"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnsavedChangesWarning = void 0;
const react_1 = require("react");
/**
 * 對話框有未儲存的變更時，關閉前先確認（搭配 ConfirmModal 顯示 showConfirm）
 * Hook to warn users about unsaved changes before closing dialog
 * @param isDirty - Whether the form has unsaved changes
 * @param onConfirmClose - Callback to execute when user confirms closing
 */
const useUnsavedChangesWarning = (isDirty, onConfirmClose) => {
    const [showConfirm, setShowConfirm] = (0, react_1.useState)(false);
    const handleClose = (0, react_1.useCallback)(() => {
        if (isDirty) {
            setShowConfirm(true);
        }
        else {
            onConfirmClose();
        }
    }, [isDirty, onConfirmClose]);
    const handleConfirmClose = (0, react_1.useCallback)(() => {
        setShowConfirm(false);
        onConfirmClose();
    }, [onConfirmClose]);
    const handleCancelClose = (0, react_1.useCallback)(() => {
        setShowConfirm(false);
    }, []);
    return {
        handleClose,
        showConfirm,
        handleConfirmClose,
        handleCancelClose,
    };
};
exports.useUnsavedChangesWarning = useUnsavedChangesWarning;
